var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIRoundTick = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 -46.866)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-4 46.866)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.905 -40.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-14.644,103.054l-3.308-3.309.707-.707,2.6,2.6,7.033-7.033.707.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.05,109.886A10.866,10.866,0,0,1-23.905,99.032,10.868,10.868,0,0,1-13.05,88.176,10.868,10.868,0,0,1-2.2,99.032,10.866,10.866,0,0,1-13.05,109.886Zm0-20.71a9.866,9.866,0,0,0-9.855,9.856,9.865,9.865,0,0,0,9.855,9.854A9.865,9.865,0,0,0-3.2,99.032,9.866,9.866,0,0,0-13.05,89.176Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIRoundTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_round_tick.1ebd2fac.svg";
export { ForwardRef as ReactComponent };